import { $http } from "@/assets/js/appFunc";
import store from "@/store";

// actiunea de get care aduce diagrama din data model impreuna cu clasele si atributele aferente
export const getGeneralModelDefinition = () => store()
    .dispatch("version/getLatestVersionId")
    .then(version => {
        const req = {
            type: "GET",
            url: `/data/model/definition/version/${version}/application/${
                store().getters["main/getCurrentApplicationId"]
            }/type/apps`
        };
        return $http(req, true);
    });

// get modul dataModel
export const getDataModel = () => {
    const appId = store().getters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/dataModel/classes?applicationId=${appId}`

    };

    return $http(params, true);
};
export const getGeneralDiagrams = (customData) => store()
    .dispatch("version/getLatestVersionId")
    .then(version => {
        const req = {
            type: "GET",
            url: `/data/model/definition/version/${version}/application/${
                store().getters["main/getCurrentApplicationId"]
            }`,
            data: null
        };
        return $http(req, true).then(
            data => {
                if (data.data.length) {
                    return getGeneralModelDefinition(customData);
                }
                return false;
            },
            error => console.log(error)
        );
    });
// save-ul mare de pe diagrama din data model and catalogs
export const saveGenericModelDefinition = (payload) => {
    const appId = store().getters["main/getCurrentApplicationId"];
    const req = {
        type: "POST",
        url: `/design/dataModel/diagram?applicationId=${appId}`,
        data: payload
    };
    return $http(req, true);
};

// save de lista clase
export const saveDataModelClass = (payload) => {
    const params = {
        type: "POST",
        url: "/design/dataModel/classes",
        headers: { "Content-Type": "application/json" },
        data: payload

    };

    return $http(params, true);
};

export const deleteDataModelClass = (payload) => {
    const appId = store().getters["main/getCurrentApplicationId"];
    const params = {
        type: "PUT",
        url: `/design/dataModel/classes/${payload.id}?applicationId=${appId}`,
        data: payload.diagram
    };
    return $http(params, true);
};
